import { HubEvents } from "../common/HubEventsEnum";
import { GridBaseModel } from "../common/GridBaseModel";

export class BenefitsHub extends GridBaseModel {
  hubName: string = "benefits";

  constructor() {
    super("benefits");
  }

  onLoadData = callback => this.registerIncomingEvent(HubEvents.ON_LOAD_BENEFIT_DATA, callback);

  invokeLoadData = async (organisationId: number, projectId: number) => {
    if (!this.isConnectionStarted) return;
    await this.connection.invoke(HubEvents.INVOKE_LOAD_BENEFIT_DATA, {
      organisationId: organisationId,
      projectId: projectId
    });
  };
}

const instance = new BenefitsHub();
export default instance;
